import { Button } from 'react-bootstrap';
import styled from 'styled-components';
import { device } from '../../../constants';
import { useTheme } from '../../../contexts/ThemeContext';
import { ChevronUpIcon } from '../../assets/icons/chevrons-up';
export const BackTopButtonContainer = styled(Button)`
  padding: 0;
  position: fixed;
  right: 8px;
  bottom: 8px;
  display: none;
  
  height: 32px;
  width: 32px;

  background-color: ${({ theme }) => theme.colors['branding-02']} !important;
  border-radius: 50%;
  border: none;

  justify-content: center;
  align-items: center;
  
  svg {
    width: 16px;
    height: 16px;
  }
  
  @media ${device.laptop} {
    display: flex;
    right: 16px;
    bottom: 16px;
    
    height: 48px;
    width: 48px;

    svg {
      width: 24px;
      height: 24px;
    }
  }

  :is([data-theme="dark"] &) {
    background-color: ${({ theme }) => theme.colors['vivid-02']} !important;
  }
`;

const BackToTopButton = () => {
  const { theme } = useTheme();
  const goToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const iconColor = theme === 'dark' ? '#1D202A' : '#fff';

  return (
    <BackTopButtonContainer onClick={goToTop}>
      <ChevronUpIcon color={iconColor} />
    </BackTopButtonContainer>
  )
}

export default BackToTopButton
